/* LEORA landing — reveals, navegación y escenas cinemáticas por scroll. Sin dependencias. */
(function () {
  var root = document.querySelector('.lx');
  if (!root) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
  var seg = function (p, a, b) { return clamp((p - a) / (b - a)); };
  var smooth = function (t) { return t * t * (3 - 2 * t); };
  var vh = function () { return window.innerHeight || document.documentElement.clientHeight; };

  /* ---------------- reveals ---------------- */
  var pending = Array.prototype.slice.call(root.querySelectorAll('.lx-rv'));
  if (reduced) { pending.forEach(function (el) { el.classList.add('is-in'); }); pending = []; }
  var counts = {};
  function revealPass() {
    if (!pending.length) return;
    var h = vh(), still = [];
    for (var i = 0; i < pending.length; i++) {
      var el = pending[i], r = el.getBoundingClientRect();
      if (r.top < h * 0.9) {
        var g = el.closest('[data-stagger]'), delay = 0;
        if (g && r.top > 0) {
          var k = g.getAttribute('data-k');
          if (!k) { k = 'g' + Math.random().toString(36).slice(2); g.setAttribute('data-k', k); }
          counts[k] = counts[k] || 0;
          delay = Math.min(counts[k], 9) * 70;
          counts[k]++;
        }
        el.style.setProperty('--d', delay + 'ms');
        el.classList.add('is-in');
      } else { still.push(el); }
    }
    pending = still;
  }

  /* ---------------- escenas con pin ---------------- */
  var scenes = Array.prototype.slice.call(root.querySelectorAll('[data-scene]')).map(function (el) {
    return { el: el, kind: el.getAttribute('data-scene'), last: -1 };
  });

  function setVars(el, map) { for (var k in map) el.style.setProperty(k, map[k]); }

  function paintScene(s) {
    var el = s.el;
    var r = el.getBoundingClientRect();
    var h = vh();
    if (r.bottom < -120 || r.top > h + 120) return;

    var travel = el.offsetHeight - h;
    var p = travel <= 0 ? (r.top <= 0 ? 1 : 0) : clamp(-r.top / travel);
    if (Math.abs(p - s.last) < 0.0008) return;
    s.last = p;

    if (s.kind === 'ignition') {
      /* el suelo de 0.07 evita que la primera pantalla sea negro absoluto */
      var ign = Math.max(0.07, smooth(seg(p, 0.12, 0.56)));
      setVars(el, {
        '--p': p.toFixed(4),
        '--ign': ign.toFixed(4),
        '--bloom': smooth(seg(p, 0.13, 0.60)).toFixed(4),
        '--zoom': (1.13 - 0.13 * smooth(seg(p, 0.04, 0.92))).toFixed(4),
        /* la frase de apertura ya se ve al cargar y se retira al encender */
        '--o1': (1 - seg(p, 0.15, 0.30)).toFixed(4),
        '--o2': smooth(seg(p, 0.30, 0.46)).toFixed(4),
        '--o3': smooth(seg(p, 0.52, 0.68)).toFixed(4)
      });
      el.classList.toggle('is-ready', p > 0.62);
    } else if (s.kind === 'reveal') {
      var mix = smooth(seg(p, 0.12, 0.72));
      setVars(el, { '--p': p.toFixed(4), '--mix': mix.toFixed(4) });
      var pct = el.querySelector('[data-pct]');
      if (pct) pct.textContent = Math.round(mix * 100) + '%';
      var lbl = el.querySelector('[data-onoff]');
      if (lbl) lbl.textContent = mix < 0.04 ? 'Apagada' : (mix > 0.96 ? 'Encendida' : 'Encendiendo');
    }
  }

  function paintAll() { for (var i = 0; i < scenes.length; i++) paintScene(scenes[i]); }

  /* ---------------- navegación flotante ---------------- */
  var nav = root.querySelector('.lx-nav');
  var links = nav ? Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]')) : [];
  var targets = links.map(function (a) { return document.querySelector(a.getAttribute('href')); });
  var firstScene = root.querySelector('[data-scene="ignition"]');
  function navPass() {
    if (!nav) return;
    var y = window.scrollY || window.pageYOffset || 0;
    var gate = firstScene ? firstScene.offsetHeight * 0.5 : 500;
    nav.classList.toggle('is-vis', y > gate);

    var h = vh(), best = -1, bestTop = -Infinity;
    for (var i = 0; i < targets.length; i++) {
      var t = targets[i];
      if (!t) continue;
      var top = t.getBoundingClientRect().top;
      if (top < h * 0.45 && top > bestTop) { bestTop = top; best = i; }
    }
    for (var j = 0; j < links.length; j++) {
      if (!links[j].classList.contains('lx-nav__buy')) links[j].classList.toggle('is-active', j === best);
    }
  }

  /* ---------------- eventos ----------------
     Todo se pinta de forma síncrona en el scroll: así funciona aunque el
     navegador tenga pausado requestAnimationFrame. El bucle rAF sólo añade
     suavidad extra mientras la pestaña está visible. */
  function tick() { paintAll(); revealPass(); navPass(); }

  function frame() {
    if (!document.hidden) paintAll();
    window.requestAnimationFrame(frame);
  }

  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', function () {
    scenes.forEach(function (s) { s.last = -1; });
    tick();
  }, { passive: true });
  window.addEventListener('load', tick);
  document.addEventListener('visibilitychange', tick);

  tick();
  if (!reduced) window.requestAnimationFrame(frame);
  setTimeout(tick, 350);
})();